<div class="flex flex-col items-center justify-center space-y-4">
  <ng-content select="fmnts-empty-state-visual" />
  <div class="empty:hidden flex flex-col items-center space-y-2">
    <ng-content
      select="fmnts-empty-state-title,[fmnts-empty-state-title],fmnts-empty-state-description,[fmnts-empty-state-description]"
    />
  </div>
  <ng-content />
</div>
